import { createErrorHandler } from '$lib/error-reporting';

const { handleError } = createErrorHandler();

export { handleError };
